import { apiFetch } from "./config.js";
/** The org-wide alert thresholds/channels. Any signed-in user can read these. */
export async function getAlertSettings(signal) {
    return apiFetch("/alert-settings", { signal });
}
/** Partial update - only fields present in `request` are changed. */
export async function updateAlertSettings(request) {
    return apiFetch("/alert-settings", { method: "PATCH", body: request });
}
